import { FormKey } from '../../enums/formKey';
import { StepKey } from '../../enums/stepKey';
import { ApplianceFormData } from '../../models/form/appliance';

export const getFormRegionOrStateCode = (formData: ApplianceFormData): string | undefined => {
  const regionOrStateCode = formData[StepKey.PERSONAL_DETAILS]?.[FormKey.STATE_CODE];
  return typeof regionOrStateCode === 'string' ? regionOrStateCode : undefined;
};
